import React, { useEffect, useState } from 'react';
import { Box, Paper, Stack, TextField, Typography } from '@mui/material';
import PendingApprovals from './PendingApprovals';
import DepartmentSelector from '../DepartmentSelector';
import AttendanceMap from './AttendanceMap';
import { employeeService } from '../../services/api';
import PendingEmployeeSelector from './PendingEmployeeSelector';

function toYyyyMm(d = new Date()){
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,'0');
  return `${y}-${m}`;
}

export default function LeaveApprovalsPage(){
  const [year, setYear] = useState(new Date().getFullYear());
  const [from, setFrom] = useState(()=>{
    const d = new Date(); d.setFullYear(d.getFullYear(),0,1); return d.toISOString().slice(0,10);
  });
  const [to, setTo] = useState(()=>{
    const d = new Date(); d.setFullYear(d.getFullYear(),11,31); return d.toISOString().slice(0,10);
  });
  const [departmentId, setDepartmentId] = useState(''); // ALL by default
  const [employeeIdFilter, setEmployeeIdFilter] = useState(''); // '' = ALL
  const [employeesById, setEmployeesById] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);

  const loadEmployees = async () => {
    try{
      const list = await employeeService.getAll();
      const map = {};
      (Array.isArray(list)?list:[]).forEach(e => {
        const id = e.id ?? e.Id;
        const fullName = e.fullName || `${e.person?.firstName || ''} ${e.person?.lastName || ''}`.trim();
        map[String(id)] = { ...e, fullName };
      });
      setEmployeesById(map);
    }catch(e){
      console.warn('Failed to load employees for department filter', e);
      setEmployeesById({});
    }
  };

  useEffect(()=>{ loadEmployees(); },[]);

  const header = (
    <Box sx={{ mb:2, display:'grid', gridTemplateColumns:{ xs:'1fr', sm:'1fr 120px 400px 400px' }, columnGap: 2, alignItems:'center' }}>
      <Typography variant="h6">Leave Approvals</Typography>
      <TextField
        type="number"
        size="small"
        label="Year"
        value={year}
        onChange={(e)=>{ const y=parseInt(e.target.value)||new Date().getFullYear(); setYear(y); setFrom(`${y}-01-01`); setTo(`${y}-12-31`); }}
        sx={{ '& .MuiInputBase-root': { height: 40 }, width: { xs:'100%', sm:120 } }}
      />
      <DepartmentSelector
        value={departmentId}
        onChange={(v)=>setDepartmentId(v || '')}
        label="Department (All)"
        placeholder="Choose department"
        size="small"
        sx={{ width: { xs:'100%', sm:400 } }}
      />
      <Box sx={{ width: { xs:'100%', sm:400 } }}>
        <PendingEmployeeSelector value={employeeIdFilter} onChange={(v)=>{ setEmployeeIdFilter(v||''); setRefreshKey(k=>k+1); }} />
      </Box>
    </Box>
  );

  return (
    <Box sx={{ p:2 }}>
      {header}
      {/* Toast/Alert позиция под заглавието в центъра */}
      <Box sx={{ display:'flex', justifyContent:'center', mb:1 }}>
        <Box id="leave-approvals-toast-anchor" />
      </Box>
      <Paper sx={{ p:2, mb:2 }}>
        <PendingApprovals key={`${from}|${to}|${departmentId}|${employeeIdFilter}|${refreshKey}`}
          from={from}
          to={to}
          departmentId={departmentId}
          employeeIdFilter={employeeIdFilter}
          employeesById={employeesById}
          onSummary={(s)=>{
            if (typeof window!=='undefined') {
              window.__leaveApprovalsSummary = s;
              window.dispatchEvent(new CustomEvent('hrapp.leave.approvals.summary', { detail: s }));
            }
          }}
          onActionSuccess={()=> setRefreshKey(k=>k+1)}
        />
      </Paper>
      <Paper sx={{ p:2 }}>
        <AttendanceMap year={year} departmentId={departmentId} employeesById={employeesById} refreshTrigger={refreshKey} />
        <Box sx={{ mt:1, display:'flex', gap:2, color:'#666', fontSize:12 }}>
          <span><span style={{background:'#4caf50', display:'inline-block', width:10, height:10, marginRight:6}}/>Approved</span>
          <span><span style={{background:'#ff9800', display:'inline-block', width:10, height:10, marginRight:6}}/>Pending</span>
          <span><span style={{background:'#7b1fa2', display:'inline-block', width:10, height:10, marginRight:6}}/>Cancel Requested</span>
          <span><span style={{background:'#f44336', display:'inline-block', width:10, height:10, marginRight:6}}/>Rejected</span>
        </Box>
      </Paper>
    </Box>
  );
}

